import { render, staticRenderFns } from "./ImageCompare.vue?vue&type=template&id=4ef9e28e&scoped=true&"
import script from "./ImageCompare.vue?vue&type=script&lang=js&"
export * from "./ImageCompare.vue?vue&type=script&lang=js&"
import style0 from "./ImageCompare.vue?vue&type=style&index=0&id=4ef9e28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9e28e",
  null
  
)

export default component.exports